import * as React from "react";

function SvgStraight1Shadow(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" filter="url(#straight-1-shadow_svg__a)" enableBackground="new 0 0 1600 200" {...props}><filter id="straight-1-shadow_svg__a"><feGaussianBlur in="SourceAlpha" stdDeviation={4} /><feComponentTransfer><feFuncA type="linear" slope={0.4} /></feComponentTransfer><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /></feMerge></filter><path d="M-10 121.6h1620v-16.4H-10z" /></svg>;
}

export default SvgStraight1Shadow;